import { BaseQueryApi, FetchArgs, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';


const baseQuery = fetchBaseQuery({
    baseUrl: "https/://localhost:44309/api/",
    // baseUrl: "/api/",
});

export const api = createApi({
    baseQuery: async (
        args: string | FetchArgs,
        api: BaseQueryApi,
        extraOptions: {}
    ) => {
        //check token expire time

        return await baseQuery(args, api, extraOptions)
    },
    endpoints: (builder: any) => ({
        // refreshToken: builder.mutation({
        //     query: () => 'Login/refresh-token',
        //     method: 'POST',
        //     headers: (headers: any) => {
        //         const token = localStorage.getItem('token');
        //         if (token) {
        //             headers['Authorization'] = `Bearer ${token}`;
        //         }
        //         return headers;
        //     },
        // }),

        // userEndpoint: builder.query({
        //     query: (token: any) => ({
        //         url: 'User/UserEndpointJson',
        //         method: 'GET',
        //         headers: {
        //             'Content-Type': 'application/json',
        //             Authorization: `Bearer ${token}`,
        //         },
        //     }),
        // }),
    }),
});


export const blobExcelOption: FetchArgs = {
    url: "",
    method: "GET",
    responseHandler: (response) =>
        response.blob().then((blob) => URL.createObjectURL(blob)),
    // responseHandler: async (response) =>
    //   await response.blob().then((blob) => URL.createObjectURL(blob)),
    cache: "no-cache",
};

export default api; 